<script>
	import { Route, Router } from "svelte-routing";
	import AppBreadcrumb from "../components/AppBreadcrumb/AppBreadcrumb.svelte";
	import Header from "../components/Header/Header.svelte";
	import Sidebar from "../components/Sidebar/Sidebar.svelte";
	import AccountManagement from "../views/AccountManagement/AccountManagement.svelte";
	import FmsAccountManagement from "../views/FMSAccountManagement/FMSAccountManagement.svelte";
	import Dashboard from "../views/Dashboard.svelte";
	import JobManagement from "../views/JobManagement/JobManagement.svelte";
	import IssueManagement from "../views/IssueManagement/IssueManagement.svelte";
	import CarManagement from "../views/CarManagement/CarManagement.svelte";
	import CarparkManagement from "../views/CarparkManagement/CarparkManagement.svelte";
	import FuelCardManagement from "../views/FuelCardManagement/FuelCardManagement.svelte";
	import EvAccManagement from "../views/EvAccManagement/EvAccManagement.svelte";
	import BlackoutManagement from "../views/BlackoutManagement/BlackoutManagement.svelte";
	import EvManagement from "../views/EvManagement/EvManagement.svelte";
	import MasterData from "../views/MasterData/MasterData.svelte";
	export let location;
	import NotFound from "../views/NotFound.svelte";
	import {
		errorMessage,
		userRole,
		userName,
		toastMessage,
	} from "../store/store";
	import Account from "../views/Account/Account.svelte";
	import Servicing from "../views/Servicing/Servicing.svelte";
	import CustomToast from "../components/CustomToast/CustomToast.svelte";
	import Issues from "../views/Issues/Issues.svelte";
	// import { doLogout } from "src/store/auth/auth";

	let width;
	let message;
	let type;
	let breakPointWidth = 960;
	$: isCollapsed = width < breakPointWidth;
	let token = localStorage.getItem("token");
	let authenticated = Boolean(token);

	toastMessage.subscribe((value) => {
		message = value.message;
		type = value.type;
	});

	function toggleSidebar() {
		isCollapsed = !isCollapsed;
	}
</script>

<div class="app" bind:clientWidth={width}>
	<!-- <LoaderContainer /> -->
	<div class="app-container">
		<div
			class={`sidebar-container ${
				isCollapsed ? "sidebar-collapse" : "sidebar-open"
			}`}
		>
			<Sidebar
				{location}
				{toggleSidebar}
				{isCollapsed}
				{breakPointWidth}
				{width}
			/>
		</div>
		<main
			class={`content-container ${
				isCollapsed
					? "content-container-collapse"
					: "content-container-open"
			} `}
		>
			<!-- <Header {userName} /> -->
			<div class="container-fluid p-4">
				<AppBreadcrumb {location} />
				<Router url="/">
					<Route path="/dashboard" component={Dashboard} />
					<Route path="/jobs/*" component={JobManagement} />
					<Route path="/servicing/*" component={Servicing} />
					{#if $userRole.includes(6)}
						<Route path="/account/*" component={Account} />
					{:else}
						<Route
							path="/account-management/*"
							component={NotFound}
						/>
					{/if}
					{#if $userRole.includes(2)}
						<Route
							path="/car-management/*"
							component={CarManagement}
						/>
					{:else}
						<Route path="/car-management/*" component={NotFound} />
					{/if}
					<Route
						path="/issue-management/*"
						component={IssueManagement}
					/>
					<Route path="/issues/*">
						<Issues {location} />
					</Route>
					{#if $userRole.includes(3)}
						<Route
							path="/carpark-management/*"
							component={CarparkManagement}
						/>
					{:else}
						<Route
							path="/carpark-management/*"
							component={NotFound}
						/>
					{/if}
					{#if $userRole.includes(3)}
						<Route
							path="/EV-charging-lot-management/*"
							component={EvManagement}
						/>
					{:else}
						<Route
							path="/EV-charging-lot-management/*"
							component={NotFound}
						/>
					{/if}
					{#if $userRole.includes(4)}
						<Route
							path="/blackout-management/*"
							component={BlackoutManagement}
						/>
					{:else}
						<Route
							path="/blackout-management/*"
							component={NotFound}
						/>
					{/if}
					{#if $userRole.includes(5)}
						<Route
							path="/fuel-card-management/*"
							component={FuelCardManagement}
						/>
					{:else}
						<Route
							path="/fuel-card-management/*"
							component={NotFound}
						/>
					{/if}
					{#if $userRole.includes(5)}
						<Route
							path="/ev-account-management/*"
							component={EvAccManagement}
						/>
					{:else}
						<Route
							path="/ev-account-management/*"
							component={NotFound}
						/>
					{/if}
					{#if $userRole.includes(9)}
						<Route path="/master-data/*" component={MasterData} />
					{:else}
						<Route path="/master-data/*" component={NotFound} />
					{/if}
					<Route path="/not-found" component={NotFound} />
				</Router>
			</div>
			<CustomToast {message} {type} />
		</main>
	</div>
</div>
